module.exports = __webpack_public_path__ + "img/reviews-image2.b5bf3145.jpg";